"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const userSelectors_1 = require("../../../selectors/userSelectors");
const zustandStore_1 = require("../../../zustandStore");
const approvalsContainer_1 = __importDefault(require("../approvals/approvalsContainer"));
const approvalsHeaderActions_1 = __importDefault(require("../approvals/approvalsHeaderActions"));
const approvalsList_1 = __importDefault(require("../approvals/approvalsList"));
const activityHeaderActions_1 = __importDefault(require("./activityHeaderActions"));
const lexico = new lexico_1.default();
const ActivityPage = () => {
    const theme = (0, material_1.useTheme)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { showNoActiveCardInfo, viewAllApprovals } = (0, zustandStore_1.useZustand)(state => ({
        showNoActiveCardInfo: state.approvals.showNoActiveCardInfo,
        viewAllApprovals: state.activity.viewAllApprovals,
    }));
    const showAllApprovals = (initialData && 'user' in initialData && (0, userSelectors_1.isCompanyOrSupportAdmin)(initialData.user?.roles || [])) ||
        viewAllApprovals;
    return ((0, jsx_runtime_1.jsxs)(approvalsContainer_1.default, { children: [showNoActiveCardInfo && ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Alert, { sx: { width: '100%', marginBottom: theme.tsGoUnit.tsUnitHalf }, "data-testid": "card-status-alert", severity: "warning", children: lexico.trc('Warning message', 'There are no active cards for this team') }) })), showAllApprovals ? (0, jsx_runtime_1.jsx)(activityHeaderActions_1.default, {}) : (0, jsx_runtime_1.jsx)(approvalsHeaderActions_1.default, {}), (0, jsx_runtime_1.jsx)(approvalsList_1.default, {})] }));
};
exports.default = ActivityPage;
